import { render, staticRenderFns } from "./TextImageCard.vue?vue&type=template&id=28da0b76&scoped=true"
import script from "./TextImageCard.vue?vue&type=script&lang=js"
export * from "./TextImageCard.vue?vue&type=script&lang=js"
import style0 from "./TextImageCard.vue?vue&type=style&index=0&id=28da0b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28da0b76",
  null
  
)

export default component.exports